import React from "react";
import "./index.css";

const Loading = () => {
  return (
    <button className="button is-fullwidth is-large is-loading loading is-white" disabled>
      Loading...
    </button>
  );
};

export default Loading;
